import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'parseSafeHtml'
})
export class ParseSafeHtmlPipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): unknown {
    let result: string = '';
    try {
      if (value) {
        var doc = new DOMParser().parseFromString(value, "text/html");
        result = doc.documentElement.textContent;
      }
    }
    catch (ex) {
      console.error(ex);
    }

    return result;
  }
}
